import React, { useState } from 'react';
import TopBarChinese from "../components/TopBarChinese";
import FooterChinese from "../components/FooterChinese";
import "../App.css";
import "./BookingForm.css";

function BookingFormChinese() {
  const [formData, setFormData] = useState({
    fullName: '',
    emailAddress: '',
    phoneNumber: '',
    date: '',
    time: '',
    service: '',
    additionalDetails: '',
    careRecipientName: '',
    careRecipientAge: '',
    relationshipToCareRecipient: '',
    staffGenderPreference: '',
    typeOfCare: '',
    preferredSchedule: '',
    preferredStartDate: '', // Changed to empty string
    serviceLocation: '',
    preferredContactMethod: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const emailBody = `
      全名: ${formData.fullName}\n
      電子郵件地址: ${formData.emailAddress}\n
      電話號碼: ${formData.phoneNumber}\n
      護理對象全名: ${formData.careRecipientName}\n
      護理對象年齡: ${formData.careRecipientAge}\n
      與護理對象的關係: ${formData.relationshipToCareRecipient}\n
      CHC 員工性別偏好: ${formData.staffGenderPreference}\n
      所需護理類型: ${formData.typeOfCare}\n
      首選時間表: ${formData.preferredSchedule}\n
      首選開始日期: ${formData.preferredStartDate}\n
      服務地點: ${formData.serviceLocation}\n
      首選聯繫方式: ${formData.preferredContactMethod}\n
      其他詳情: ${formData.additionalDetails}\n
    `;

    window.location.href = `mailto:info@example.com?subject=預訂請求&body=${encodeURIComponent(emailBody)}`;
  };

  return (
    <div className='App'>
      <TopBarChinese />
      <div className="App-header-services" id="contact-form" style={{ padding: '8vw 8px 8px 8px', marginBottom: '10vh' }}>
        <div className="booking-text" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-title" >預訂服務</h1>
          <p className="hero-subtitle" style={{ fontSize: '1.2rem', color: '#333', marginBottom: '32px' }}>
            請填寫以下表格以預訂服務。我們將與您聯繫以確認您的預訂。
          </p>
          <form onSubmit={handleSubmit} className="booking-form-container">
            <input 
              type="text" 
              name="fullName" 
              placeholder="全名" 
              required 
              className="booking-form-input"
              value={formData.fullName}
              onChange={handleChange}
            />
            <input 
              type="tel" 
              name="phoneNumber" 
              placeholder="電話號碼" 
              required 
              className="booking-form-input"
              value={formData.phoneNumber}
              onChange={handleChange}
            />
            <input 
              type="email" 
              name="emailAddress" 
              placeholder="電子郵件地址" 
              required 
              className="booking-form-input"
              value={formData.emailAddress}
              onChange={handleChange}
            />

            <h3>護理對象信息</h3>
            <input 
              type="text" 
              name="careRecipientName" 
              placeholder="護理對象全名" 
              required 
              className="booking-form-input"
              value={formData.careRecipientName}
              onChange={handleChange}
            />
            <input 
              type="number" 
              name="careRecipientAge" 
              placeholder="護理對象年齡" 
              required 
              className="booking-form-input"
              value={formData.careRecipientAge}
              onChange={handleChange}
              min="0"
              title="請輸入有效的年齡。"
            />
            <input 
              type="text" 
              name="relationshipToCareRecipient" 
              placeholder="與護理對象的關係" 
              required 
              className="booking-form-input"
              value={formData.relationshipToCareRecipient}
              onChange={handleChange}
            />
            <select 
              name="staffGenderPreference" 
              required 
              placeholder="CHC 員工性別偏好"
              className="booking-form-select"
              value={formData.staffGenderPreference}
              onChange={handleChange}
            >
              <option value="Male">男性</option>
              <option value="Female">女性</option>
            </select>
            <input 
              type="text" 
              name="typeOfCare" 
              placeholder="所需護理類型" 
              required 
              className="booking-form-input"
              value={formData.typeOfCare}
              onChange={handleChange}
            />
            <select 
              name="preferredSchedule" 
              required 
              placeholder="首選時間表"
              className="booking-form-select"
              value={formData.preferredSchedule}
              onChange={handleChange}
            >
              <option value="Full-Time Care">全職護理</option>
              <option value="Part-Time Care">兼職護理</option>
              <option value="Overnight Care">過夜護理</option>
            </select>
            <input 
              type="text" 
              name="preferredStartDate" 
              placeholder="首選開始日期 (dd/mm/yyyy)" 
              required 
              className="booking-form-input"
              title="請以 dd/mm/yyyy 格式輸入日期。"
              value={formData.preferredStartDate}
              onChange={handleChange}
            />
            <input 
              type="text" 
              name="serviceLocation" 
              placeholder="服務地點（城市/郵政編碼）" 
              required 
              className="booking-form-input"
              value={formData.serviceLocation}
              onChange={handleChange}
            />
            <select 
              name="preferredContactMethod" 
              required 
              placeholder="首選聯繫方式"
              className="booking-form-select"
              value={formData.preferredContactMethod}
              onChange={handleChange}
            >
              <option value="Phone">電話</option>
              <option value="Email">電子郵件</option>
              <option value="Text Message">短信</option>
            </select>

            <h3>其他詳情</h3>
            <textarea 
              name="additionalDetails" 
              placeholder="告訴我們更多關於您的護理需求或其他專業服務的信息" 
              rows="5" 
              className="booking-form-textarea"
              value={formData.additionalDetails}
              onChange={handleChange}
            />
            <button 
              type="submit" 
              className="button-arrow"
            >
              提交預訂
            </button>
          </form>
        </div>
      </div>
      <FooterChinese />
    </div>
  );
}

export default BookingFormChinese;